import React, { useEffect, useState } from 'react';
import AddBtn from "../../Assets/addIcon.png"
import RemoveBtn from "../../Assets/removeIcon.png"
import { useDispatch, useSelector } from 'react-redux';
import { addItem, addNote } from '../../redux/action';

const Note = ({ id, tab, title, note, tableName }) => {

    const dispatch = useDispatch()
    const fullCartState = useSelector((state) => state?.user.cart);
    const currentTableCart = fullCartState?.[tableName] || {};
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [noteText, setNoteText] = useState(currentTableCart[id]?.note || "");
      console.log("id",id)
      console.log("tab",tab)
      console.log("title",title)
      console.log("note",note)
      console.log("cart",fullCartState)
    useEffect(() => {
      if (note !== undefined && note !== null) {
         setNoteText(note);
      }
    }, [note]);


    const handleSaveNote = () => {
        // Logic to save to Redux/Cart would go here
        dispatch(addNote({ id: id, note: noteText, tableName: tableName }));
        console.log(`Saving note for ${noteText}`);
        setIsPopupOpen(false);
    };

    const togglePopup = (e) => {
        e.stopPropagation(); // Prevents navigating to detail page
        setNoteText(currentTableCart[id]?.note || "");
        setIsPopupOpen(!isPopupOpen);
    };

    return (
        <>
              <div className="addNoteLabel" onClick={togglePopup}>
                     <span>👨‍🍳 Add Note to Chef</span>
               </div>

                       {/* --- NOTE POPUP MODAL --- */}
            {isPopupOpen && (
                <div className="noteModalOverlay" onClick={togglePopup}>
                    <div className="noteModalContent" onClick={(e) => e.stopPropagation()}>
                        <h3>Add Note for {title}</h3>
                        <textarea 
                            className="noteTextArea"
                            placeholder="Example: Make it extra spicy / No onions"
                            value={noteText}
                            onChange={(e) => setNoteText(e.target.value)}
                            autoFocus
                        />
                        <div className="noteModalButtons">
                            <button className="cancelNoteBtn" onClick={togglePopup}>Cancel</button>
                            <button className="saveNoteBtn" onClick={handleSaveNote}>Save Note</button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Note;